export type DefaultTextProps = {
    text: string;
}

export default function DefaultTextView({ text }: DefaultTextProps) {
    return <div
        className="primary-background-color primary-color font-smaller"
        style={{
            display: "inline-block",
            borderRadius: "5px",
            padding: "0px 5px 2px 5px",
            marginTop: 2,
            marginLeft: 2,
            fontStyle: "italic"
        }}
    >
        {text}
    </div>;
}